import React from 'react';
import { Link } from 'react-router-dom';
import Sectitle from "../Title/Sectitle";

const CloudFeatures =()=>{
    return(
        <section className="design_developers_area sec_pad">
            <div className="container">
                <Sectitle Title="Press Release" TitleP=""
                 sClass="sec_title text-center"/>
               
                <div className="text-center wow fadeInUp" data-wow-delay="0.4s">
                    <Link to="./PressRelease" className="btn_hover btn_four mt_30">Press Release</Link>
                </div>
            </div>
        </section>
    )
}
export default CloudFeatures;